import { include } from '../../doc/app/App';

include({
    name: 'InboxCard',
    doc: require('./doc.md'),
    examples: [
        {
            name: 'Example',
            import: require('./example.src'),
        },
    ],
});
